<template>
    <div class="price-tooltip table">
        <button class="price-tooltip-close" @click="closeTolltip()">
            <svg class="close"><use xlink:href="#close"></use></svg>
        </button>
        <table>
            <tr>
                <th>
                    Price
                    <span>USD</span>
                </th>
                <th>
                    Sleep
                    <span>Average Nightly Rate</span>
                </th>
                <th>
                    Eat, Play
                    <span>Typical Price Per Person</span>
                </th>
            </tr>
            <tr>
                <td>
                    $ <span>$$$</span>
                </td>
                <td>Under $200</td>
                <td>$0-25</td>
            </tr>
            <tr>
                <td>
                    $$ <span>$$</span>
                </td>
                <td>$200-500</td>
                <td>$25-75</td>
            </tr>
            <tr>
                <td>
                    $$$ <span>$</span>
                </td>
                <td>$500-800</td>
                <td>$75-150</td>
            </tr>
            <tr>
                <td>$$$$</td>
                <td>$800+</td>
                <td>$150+</td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {

    mounted() {
        $(document).on('click', '#price-section  .filter-info-popup-trigger', function () {
            $(this).toggleClass('active')
        })
    },

    methods: {
        closeTolltip() {
            $('#price-section  .filter-info-popup-trigger').removeClass('active')
        }
    }
}
</script>
